export default "__VITE_ASSET___TmJ4kfB__"